/* eslint-disable import/no-anonymous-default-export */
import dark from "./Dark";
import light from "./Light";

export default {
  dark,
  light,
};
